import React from "react";
import { ExtendedProjectInfoDc } from "@evergis/api";
import { useTranslation } from "react-i18next";

import { CardControls } from "../CardControls/CardControls";
import { CardContent } from "./CardContent";
import { ApplyLabel } from "./ApplyLabel";

import { useProjectPreviewUrl } from "../../../../hooks/preview/usePreviewUrl";
import { useOpenProject } from "../../../../hooks/project/useOpenProject";
import { useProjectName } from "../../../../hooks/project/useProjectName";

import { CardProps } from "./Card";

export const ProjectCard = ({ resource }: CardProps<ExtendedProjectInfoDc>) => {
  const { t } = useTranslation();
  const preview = useProjectPreviewUrl(resource.name);
  const openProject = useOpenProject(resource.name);
  const currentProjectName = useProjectName();
  const opened = currentProjectName === resource.name;

  return (
    <CardContent
      resource={resource}
      preview={preview}
      applyLabel={
        <ApplyLabel
          text={t("actions.open", { ns: "common" })}
          appliedText={t("projectCardOpened", { ns: "catalog" })}
          applied={opened}
        />
      }
      disabled={opened}
      onOpen={openProject}
    >
      <CardControls
        resource={resource}
        config={{
          infoIcon: {
            title: t("projectInfo", { ns: "catalog" }),
          },
        }}
      />
    </CardContent>
  );
};
